module.exports = __webpack_public_path__ + "img/reputation2.339461a5.svg";